import { httpClientRepository } from '@bg-shared/infrastructure/HttpClient';
import HowToPlayEntity from './HowToPlay.entity';

export const howToPlayEntity = new HowToPlayEntity(httpClientRepository);
